import { MESFMain } from "@dexteel/mesf-core";

import "material-icons";
import "material-symbols";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./setup/ag-grid";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

render(
	<MESFMain
		showAreaSelector={true}
		routes={CustomRoutes}
		navbar={CustomNavbar}
		navbarTitle={"SWV MES"}
		configurations={customConfigurations as any}
		authentication={AuthenticationConfig}
	/>,
	document.getElementById("root"),
);
